import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const cards = [
  ["new_prayers", "New prayers", "/admin/new"],
  ["urgent", "Flagged for review", "/admin/new"],
  ["active", "Active prayers", "/admin/circle"],
  ["pending_updates", "Updates awaiting review", "/admin/updates"],
  ["still_held", "Still being held", "/admin/circle"],
  ["answered", "Answered prayers", "/admin/answered"],
  ["service_offers", "Offers to help", "/admin/people"],
  ["approved_quotes", "Approved quotes", "/admin/words"],
];

export default function AdminDashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)); }, []);

  return (
    <div className="p-8 md:p-12 max-w-5xl">
      <p className="mono-label mb-3">The Steward's Desk</p>
      <h1 className="font-heading text-4xl md:text-5xl text-ink leading-none">Dashboard</h1>
      <p className="font-body text-lg text-ink-secondary mt-5 leading-relaxed max-w-2xl">
        Receive, read, discern, approve, select, hold, revisit, update, acknowledge, give thanks. The software supports your discernment — it never decides for you.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-ink/15 border border-ink/15 mt-12">
        {cards.map(([key, label, to]) => (
          <Link key={key} to={to} className="bg-paper p-8 hover:bg-paper-tertiary" data-testid={`stat-${key}`}>
            <div className={`font-heading text-5xl ${key === "urgent" && stats[key] > 0 ? "text-terracotta" : "text-ink"}`}>{stats[key] ?? "—"}</div>
            <div className="mono-label mt-3">{label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-14 paper-rule pt-10">
        <h2 className="font-heading text-2xl text-ink mb-6">Sunday evening ritual</h2>
        <ol className="space-y-3">
          {[
            ["Open Prayer Circle → Candidates for Monday", "/admin/circle"],
            ["Read carefully and tick perhaps five names", "/admin/circle"],
            ["Add one long-standing prayer (Still Being Held)", "/admin/vigil"],
            ["Choose one answered prayer and one verified teaching", "/admin/vigil"],
            ["Preview and publish Monday's Vigil", "/admin/vigil"],
          ].map(([t, to], i) => (
            <li key={i} className="flex items-baseline gap-4">
              <span className="mono-label">{String(i + 1).padStart(2, "0")}</span>
              <Link to={to} className="font-heading text-xl text-ink hover:text-terracotta">{t}</Link>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
